import { formatNumber, Stack } from 'ui';

import { formatPercentageFeature } from '../../utils/formatFeature/formatFeature';
import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';
import { MaterialSampleBreakdownItem } from '../MaterialSampleBreakdownItem/MaterialSampleBreakdownItem';

const ALUMINIUM_SUM_KEYS: string[] = [
  'Aluminium - UBC',
  'Aluminium - Foil and Tray',
  'Aluminium - Food Can',
  'Other Aluminium (aerosols)',
  'Other Aluminium',
];

const NON_ALUMINIUM_SUM_KEYS: string[] = [
  'Other Metal',
  'Aluminium - Vapes',
  'Non-Metal',
  'Aluminium - Rigid Plastics',
  'Film',
];

export const AluMaterialSampleBreakdown = ({
  totalWeight,
  breakdown,
  precision = 1,
}: {
  totalWeight: number;
  breakdown: Record<string, number>;
  precision?: number;
}) => {
  const totalAluminium = ALUMINIUM_SUM_KEYS.reduce((acc, key) => acc + (breakdown[key] ?? 0), 0);
  const totalNonAluminium = NON_ALUMINIUM_SUM_KEYS.reduce((acc, key) => acc + (breakdown[key] ?? 0), 0);

  return (
    <Stack gap={2}>
      <div>
        <MaterialBreakdownItem
          label={'Aluminium'}
          variant="bold"
          value={formatNumber(totalAluminium, {
            maximumFractionDigits: precision,
            minimumFractionDigits: precision,
            style: 'kilogram',
          })}
          secondaryValue={totalAluminium > 0 ? formatPercentageFeature(totalAluminium / totalWeight) : '0%'}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown['Aluminium - UBC']}
          label={'UBC'}
          totalWeight={totalWeight}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown['Aluminium - Foil and Tray']}
          label={'Foil and Tray'}
          totalWeight={totalWeight}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown['Aluminium - Food Can']}
          label={'Food Can'}
          totalWeight={totalWeight}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={(breakdown['Other Aluminium (aerosols)'] ?? 0) + (breakdown['Other Aluminium'] ?? 0)}
          label={'Other Aluminium'}
          totalWeight={totalWeight}
        />
      </div>

      <div>
        <MaterialBreakdownItem
          label={'Non-Aluminium'}
          variant="bold"
          value={formatNumber(totalNonAluminium, {
            maximumFractionDigits: precision,
            minimumFractionDigits: precision,
            style: 'kilogram',
          })}
          secondaryValue={totalNonAluminium > 0 ? formatPercentageFeature(totalNonAluminium / totalWeight) : '0%'}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={(breakdown['Other Metal'] ?? 0) + (breakdown['Aluminium - Vapes'] ?? 0)}
          label={'Other Metal'}
          totalWeight={totalWeight}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={(breakdown['Non-Metal'] ?? 0) + (breakdown['Aluminium - Rigid Plastics'] ?? 0) + (breakdown.Film ?? 0)}
          label={'Non-Metal'}
          totalWeight={totalWeight}
        />
      </div>
      <MaterialBreakdownItem
        label="Total"
        value={formatNumber(totalWeight, {
          maximumFractionDigits: precision,
          minimumFractionDigits: precision,
          style: 'kilogram',
        })}
        secondaryValue={'100%'}
        variant="bold"
      />
    </Stack>
  );
};
